
import ArticleLoadingCard from '../card/ArticleLoadingCard.vue';
export default {
    name: 'article-loading-container',
    components: {
        ArticleLoadingCard
    }
}
